import { Component, input, model } from '@angular/core';

import { ReactiveFormsModule, AbstractControl, FormControl } from '@angular/forms';

import { DynamicFormField } from '../../../models/dynamic-form';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTimepickerModule } from '@angular/material/timepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { provideNativeDateAdapter } from '@angular/material/core';

@Component( {
  selector: 'app-dynamic-field-datepicker',
  providers: [provideNativeDateAdapter()],
  imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatDatepickerModule, MatTimepickerModule],
  templateUrl: './dynamic-field-datepicker.html',
  styleUrl: './dynamic-field-datepicker.css',

} )
export class DynamicFieldDatepicker
{
  public field = input.required<DynamicFormField>();
  public control = model.required<AbstractControl>();
  public formControl!: FormControl;
  public label: string = '';

  ngOnInit(): void
  {
    this.formControl = this.control() as FormControl;
  }
}
